import { createRouter, createWebHashHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import InBoundView from "../views/Inbound/List-Inbound.vue";
import MakeInBoundView from "../views/Inbound/Form-Inbound.vue";

const routes = [
  // {
  //   path: '/',
  //   name: 'inbound',
  //   component: InBoundView
  // },
  {
    path: "/inventory",
    children: [
      {
        path: "",
        name: "List Inventory",
        component: () =>
          import("../views/Inventory Management/List-Inventory.vue"),
      },
      {
        path: "form",
        name: "Form Inventory",
        component: () =>
          import("../views/Inventory Management/Form-Inventory.vue"),
      },
    ],
  },
  {
    path: "/inbound",
    name: "inbound",
    children: [
      { path: "", component: InBoundView, name: "List Inbound" },
      {
        path: "Form-Inbound/:id_staff/:id_inbound?",
        name: "Form Inbound",
        component: MakeInBoundView,
      },
    ],
  },

  {
    path: "/about",
    name: "about",
    component: () => import("../views/AboutView.vue"),
  },
  {
    path: "/stok",
    children: [
      {
        path: "",
        name: "Riwayat Pergerakan Stok",
        component: () => import("../views/Stok/List-Stok.vue"),
      },
      {
        path: "riwayat-stok/:id_stok",
        name: "Riwayat Stok",
        component: () => import("../views/Stok/Riwayat-Stok.vue"),
      },
      {
        path: "form-retur-gudang/:id_staff/:id_penyesuaian?",
        name: "Form Retur Gudang",
        component: () => import("../views/Stok/Form-Retur-Gudang"),
      },
      {
        path: "form-penyesuaian/:id_staff/:id_penyesuaian?",
        name: "Form Penyesuaian",
        component: () => import("../views/Stok/Form-Penyesuaian"),
      },
      {
        path: "list-penyesuaian-stok",
        name: "List Penyesuaian Stok",
        component: () => import("../views/Stok/List-Penyesuaian-Stok"),
      },
      {
        path: "form-retur-customer/:id_staff/:id_penyesuaian?",
        name: "Form Retur Customer",
        component: () => import("../views/Stok/Form-Retur-Customer.vue"),
      },
    ],
  },
  {
    path: "/outbound",
    children: [
      {
        path: "",
        name: "List Outbound",
        component: () => import("../views/Outbound/ListOutboundView.vue"),
      },
      {
        path: "scan/:id_staff",
        name: "Scan Outbound",
        component: () => import("../views/Outbound/ScanOutbound.vue"),
      },
      {
        path: "detail/:id",
        name: "Detail Outbound",
        component: () => import("../views/Outbound/DetailOutbound.vue"),
      },
    ],
  },
  {
    path: "/order",
    children: [
      {
        path: "",
        name: "List Pesanan",
        component: () => import("../views/Order/ListPesanan.vue"),
      },
    ],
  },
  {
    path: "/receipt",
    name: "Receipt",
    component: () => import("../views/Outbound/Receipt.vue"),
  },
  {
    path: "/kategori",
    name: "kategori",
    component: () => import("../views/setting/Kategori.vue"),
  },
  {
    path: "/merk",
    name: "merk",
    component: () => import("../views/setting/Merk.vue"),
  },

  {
    path: "/aturPengiriman",
    name: "aturPengiriman",
    component: () => import("../views/Order/AturPengiriman.vue"),
  },
  {
    path: "/tambahPesananManual",
    name: "tambahPesananManual",
    component: () => import("../views/Order/TambahPesanan.vue"),
  },
  {
    path: "/test-form",
    component: () => import("../views/backup/Form.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
